import { useState } from "react";

const KEY = "ge-invited";

/**
 * Whether this visit came from an invite email. Clerk's link carries `__clerk_ticket`; the flag
 * is kept for the tab, because Clerk's later sign-up steps drop it from the address.
 */
export const useInvited = () =>
  useState(() => {
    const ticket = new URLSearchParams(window.location.search).has("__clerk_ticket");
    try {
      if (ticket) window.sessionStorage.setItem(KEY, "1");
      return ticket || window.sessionStorage.getItem(KEY) === "1";
    } catch {
      return ticket;
    }
  })[0];
